import { useState } from 'react';

export default function WorksheetTimelineHero() {
  const [showModal, setShowModal] = useState(false);

  const scrollToPratica = () => {
    const praticaSection = document.getElementById('pratica-timeline');
    if (praticaSection) {
      praticaSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <section className="relative bg-gradient-to-br from-violet-50 via-purple-50 to-fuchsia-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-6 shadow-sm">
              <i className="ri-time-line text-violet-600 text-xl"></i>
              <span className="text-sm font-medium text-gray-700">Timeline Therapy — PNL</span>
            </div>

            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Worksheet Interativo
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-fuchsia-600 mt-2">
                Técnica da Linha do Tempo
              </span>
            </h1>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Libere emoções negativas do passado preservando os aprendizados valiosos.
              <span className="block mt-2">
                Reprograme sua linha do tempo e crie um futuro motivador.
              </span>
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
              <button
                onClick={scrollToPratica}
                className="bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                Começar Agora
              </button>
              <button
                onClick={() => setShowModal(true)}
                className="bg-white text-violet-600 px-8 py-4 rounded-full font-semibold hover:shadow-lg transition-all duration-300 border-2 border-violet-200 whitespace-nowrap"
              >
                Como Funciona?
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-heart-pulse-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Libertador</h3>
                <p className="text-sm text-gray-600">Libere emoções que te prendem ao passado</p>
              </div>

              <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-500 to-pink-600 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Seguro</h3>
                <p className="text-sm text-gray-600">Trabalhe dissociado, sem reviver traumas</p>
              </div>

              <div className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-rocket-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Transformador</h3>
                <p className="text-sm text-gray-600">Crie um futuro livre de limitações antigas</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowModal(false)}>
          <div className="bg-white rounded-3xl max-w-3xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white p-6 rounded-t-3xl">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold">Como o Cérebro Organiza o Tempo</h3>
                <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center hover:bg-white/20 rounded-full transition-colors">
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>

            <div className="p-8 space-y-6">
              <div className="bg-violet-50 border-l-4 border-violet-600 p-6 rounded-r-xl">
                <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-information-line text-violet-600"></i>
                  O Princípio da Técnica
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  Seu cérebro armazena memórias em uma estrutura espacial chamada "linha do tempo". 
                  Cada evento tem uma localização específica nessa linha. Emoções negativas ficam "presas" 
                  em eventos do passado, influenciando seu presente.
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-violet-50 to-purple-50 p-6 rounded-2xl border border-violet-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-user-heart-line text-white text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-3">In Time (Dentro do Tempo)</h4>
                  <p className="text-sm text-gray-700 mb-3">
                    Você está imerso no momento presente. O passado fica atrás e o futuro à frente.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-violet-600 mt-0.5"></i>
                      <span>Vive intensamente o agora</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-violet-600 mt-0.5"></i>
                      <span>Pode perder noção do tempo</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-violet-600 mt-0.5"></i>
                      <span>Mais emocional e espontâneo</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gradient-to-br from-fuchsia-50 to-pink-50 p-6 rounded-2xl border border-fuchsia-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-500 to-pink-600 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-calendar-line text-white text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-3">Through Time (Através do Tempo)</h4>
                  <p className="text-sm text-gray-700 mb-3">
                    Você vê o tempo como uma linha à sua frente, consegue ver passado e futuro simultaneamente.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-fuchsia-600 mt-0.5"></i>
                      <span>Pontual e organizado</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-fuchsia-600 mt-0.5"></i>
                      <span>Planeja com antecedência</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-fuchsia-600 mt-0.5"></i>
                      <span>Mais analítico e estruturado</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl">
                <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-lightbulb-line text-amber-600"></i>
                  Como a Técnica Funciona
                </h4>
                <p className="text-gray-700 leading-relaxed mb-3">
                  A Timeline Therapy permite que você "flutue" acima da sua linha do tempo, 
                  vá até o evento raiz de uma emoção negativa e a libere — preservando o aprendizado valioso.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Você trabalha sempre dissociado (vendo de fora), o que torna o processo seguro e não traumático.
                </p>
              </div>

              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-xl">
                <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-alert-line text-red-600"></i>
                  Importante — Segurança Emocional
                </h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <i className="ri-shield-check-line text-red-600 mt-0.5"></i>
                    <span>Mantenha-se sempre dissociado ao trabalhar com eventos traumáticos</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-shield-check-line text-red-600 mt-0.5"></i>
                    <span>Se a emoção ficar muito intensa, volte ao presente imediatamente</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-shield-check-line text-red-600 mt-0.5"></i>
                    <span>Para traumas profundos, busque apoio de um terapeuta qualificado</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
